import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/home/AccessStatus.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/home/FaqDialog.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/home/FeatureRing.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/home/home.module.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/font/google/target.css?{\"path\":\"app/page.tsx\",\"import\":\"Hanken_Grotesk\",\"arguments\":[{\"variable\":\"--font-hanken\",\"subsets\":[\"latin\"],\"weight\":[\"400\",\"500\"]}],\"variableName\":\"hanken\"}");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/font/google/target.css?{\"path\":\"app/page.tsx\",\"import\":\"IBM_Plex_Mono\",\"arguments\":[{\"variable\":\"--font-plex-mono\",\"subsets\":[\"latin\"],\"weight\":[\"400\",\"500\"]}],\"variableName\":\"plexMono\"}");
